/**
 * Cursor-source priorities for the cursor controller: a higher value wins, so
 * navigation (spacebar pan) beats an in-flight gesture, which beats hover, which
 * beats the active mode.
 */
export const CursorPriority = {
	MODE: 100,
	HOVER: 200,
	GESTURE: 300,
	NAVIGATION: 400,
} as const;
